module.exports = __webpack_public_path__ + "img/avatar_male.46459fff.svg";